// test489
(489 && 0);
